module.exports = __webpack_public_path__ + "img/icon_logout.ba380577.svg";